module.exports = __webpack_public_path__ + "static/media/Path235.03725237.svg";